import { computed } from "vue";
import EmployeeCustomerAccess from "@/enumerations/Security/EmployeeCustomerAccess";
import EmployeeSecurity from "@/enumerations/Security/EmployeeSecurity";
import { useAuthStore } from "@/stores/auth";

export function usePortalSecuritySettings() {
  const authStore = useAuthStore();

  const viewOnly = computed(() => {
    const selectedAccountId = authStore.selectedAccount?.id;

    return (
      authStore.webLogin.isEmployee &&
      authStore.webLogin.employeeSecurity === EmployeeSecurity.viewOnly &&
      !!selectedAccountId &&
      !authStore.selectedAccount?.isAccountLinkedToWebLogin
    );
  });

  const manager = computed(() => {
    return (
      authStore.webLogin.isEmployee &&
      (authStore.webLogin.employeeCustomerAccess ===
        EmployeeCustomerAccess.fieldRep ||
        authStore.webLogin.employeeCustomerAccess ===
          EmployeeCustomerAccess.userProfile)
    );
  });

  const managerAccountSelected = computed(() => {
    return manager.value && !authStore.selectedAccount?.id;
  });

  return {
    manager,
    managerAccountSelected,
    viewOnly,
  };
}
